export default "/list/static/images/partnerCentralLogo.svg";